import { render, staticRenderFns } from "./ModalAlterarSenha.vue?vue&type=template&id=c108b5da&scoped=true"
import script from "./ModalAlterarSenha.vue?vue&type=script&lang=js"
export * from "./ModalAlterarSenha.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarSenha.vue?vue&type=style&index=0&id=c108b5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c108b5da",
  null
  
)

export default component.exports